/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: process.env.REACT_APP_ENV === "PROD" ? "us-east-2" : "us-west-1",
  aws_cognito_region: process.env.REACT_APP_ENV === "PROD" ? "us-east-2" : "us-west-1",
  aws_user_pools_id: process.env.REACT_APP_ENV === "PROD" ? "us-east-2_L0haUXuuL" : "us-west-1_QAai4ZBAS",
  aws_user_pools_web_client_id: process.env.REACT_APP_ENV === "PROD" ? "641hadqabcgbpcgccls5mlmv45" : "2eaqbo6lv8sm686v0hd49chkfl",
  oauth: {},
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  // aws_appsync_graphqlEndpoint:
  //   "https://encdl52ro5dw3dgfemt3xqb2zi.appsync-api.us-east-2.amazonaws.com/graphql",

  aws_appsync_graphqlEndpoint: process.env.REACT_APP_ENV === "PROD" ? "https://encdl52ro5dw3dgfemt3xqb2zi.appsync-api.us-east-2.amazonaws.com/graphql" :
    "https://2swtjoy5x5cpzaxyhysztirjoe.appsync-api.us-west-1.amazonaws.com/graphql",
  aws_appsync_region: process.env.REACT_APP_ENV === "PROD" ? "us-east-2" : "us-west-1",
  aws_appsync_authenticationType: "API_KEY",
  // aws_appsync_apiKey: "da2-tk3hzmss4rhjvb6orlur23cjxu",
  aws_appsync_apiKey: process.env.REACT_APP_ENV === "PROD" ? "da2-tk3hzmss4rhjvb6orlur23cjxu" : "da2-bvxvm3ijqndwhd6o2yxvyhkp3u",
  aws_s3_region:process.env.REACT_APP_ENV === "PROD" ? "us-east-2" : "us-west-1",
  aws_s3_bucket: process.env.REACT_APP_ENV === "PROD" ? "skali-report" : "sbx-skali-report",
};

export default awsmobile;
